export const STATUS_ERROR = 'error';
export const STATUS_IDLE = 'idle';
export const STATUS_LOADING = 'loading';
export const STATUS_SUCCESS = 'success';
export const isError = status => status === STATUS_ERROR;
export const isIdle = status => status === STATUS_IDLE;
export const isLoading = status => status === STATUS_LOADING;
export const isSuccess = status => status === STATUS_SUCCESS;